// extracted by mini-css-extract-plugin
export default {"page":"superAdminOrganisationsPage_page__QIVp0","selectOrganization":"superAdminOrganisationsPage_selectOrganization__3qPms","table":"superAdminOrganisationsPage_table__B0RhY"};